export default __webpack_public_path__ + "static/media/ombbg.94aecc4e.png";